import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

@observer
export default class ClosedBox extends Component {
    render() {
        const { survey } = this.props
        return (
            <div id="editSurveyDisabledMessage" style={process.env.USE_NEW_HEADER_UI ? { marginTop: '0px' } : {}}>
                <i className="fas fa-circle-info" style={{ marginRight: 5 }} />

                {i18n.t('s_disabled_edit_survey_past_closing_date')}

                <a href={`/survey/${survey.id}`}>
                    <i className="fal fa-cog" />

                    {i18n.t('s_tab_settings')}
                </a>
            </div>
        )
    }
}
